export default __webpack_public_path__ + "6bf3a95ac688d47731cafa9d8ac2b4a1.png";